import {Power0} from 'gsap';
let fullAnimation = gsap.timeline({paused: true});

const stepOne = (el) => {
	const slow = 0.5;
	const time = 1.25;
	const time2 = 1.75;
	const tm = gsap.timeline();
	const parent = el;
	const el3 = parent.querySelector('.scheme-2-3__inner--3');
	const el4 = parent.querySelector('.scheme-2-3__inner--4');
	const el13 = parent.querySelector('.scheme-2-3__inner--13');
	const el14 = parent.querySelector('.scheme-2-3__inner--14');
	const el15 = parent.querySelector('.scheme-2-3__inner--15');
	const el16 = parent.querySelector('.scheme-2-3__inner--16');
	const el18 = parent.querySelector('.scheme-2-3__inner--18');
	const el19 = parent.querySelector('.scheme-2-3__inner--19');
	const el20 = parent.querySelector('.scheme-2-3__inner--20');
	const el21 = parent.querySelector('.scheme-2-3__inner--21');
	const el23 = parent.querySelector('.scheme-2-3__inner--23');
	const el24 = parent.querySelector('.scheme-2-3__inner--24');
	const easeAnimate = 'Sine.easeInOut';

	fullAnimation.add(tm.play());
	tm
		.to(el3, {
			ease: easeAnimate,
			duration: time2,
			x: '1.2em',
			y: '2.4em',
		}, 0)
		.to(el3, {
			ease: easeAnimate,
			duration: time2 + slow,
			x: '-1.5em',
			y: '2em',
			repeat: -1,
			yoyo: true,
		}, 0.4)
		.to(el4, {
			ease: easeAnimate,
			duration: time,
			x: '3em',
			y: '7.3em',
		}, 0)
		.to(el4, {
			ease: easeAnimate,
			duration: time + 0.5 + slow,
			x: '7.2em',
			y: '7em',
			repeat: -1,
			yoyo: true,
		})
		.to(el13, {
			ease: easeAnimate,
			duration: time,
			x: '-0.4em',
			y: '-1.6em',
		}, 0)
		.to(el13, {
			ease: easeAnimate,
			duration: time,
			x: '2.3em',
			y: '-4.6em',
			repeat: -1,
			yoyo: true,
		})
		.to(el14, {
			ease: easeAnimate,
			duration: time,
			x: '-0.3em',
			y: '-1em',
		}, 0)
		.to(el14, {
			ease: easeAnimate,
			duration: time,
			x: '2.9em',
			y: '-1.5em',
			repeat: -1,
			yoyo: true,
		})
		.to(el15, {
			ease: easeAnimate,
			duration: time,
			x: 0,
			y: 0,
		}, 0)
		.to(el15, {
			ease: easeAnimate,
			duration: time,
			x: '2.7em',
			y: '-3em',
			repeat: -1,
			yoyo: true,
		})
		.to(el16, {
			ease: easeAnimate,
			duration: time,
			x: 0,
			y: 0,
		}, 0)
		.to(el16, {
			ease: easeAnimate,
			duration: time,
			x: '3.2em',
			y: '-0.5em',
			repeat: -1,
			yoyo: true,
		})
		.to(el18, {
			ease: easeAnimate,
			duration: time,
			x: '4em',
			y: '6.9em',
			rotate: 0,
		}, 0)
		.to(el18, {
			ease: easeAnimate,
			duration: time,
			x: '7.9em',
			y: '6.4em',
			rotate: 9.32,
			repeat: -1,
			yoyo: true,
		})
		.to(el19, {
			ease: easeAnimate,
			duration: time,
			x: '2em',
			y: '6.9em',
			rotate: 0,
		}, 0)
		.to(el19, {
			ease: easeAnimate,
			duration: time,
			x: '3.8em',
			y: '7em',
			rotate: -6.59,
			repeat: -1,
			yoyo: true,
		})
		.to(el20, {
			ease: easeAnimate,
			duration: time,
			x: '4em',
			y: '6.9em',
		}, 0)
		.to(el20, {
			ease: easeAnimate,
			duration: time,
			x: '6.3em',
			y: '6.3em',
			repeat: -1,
			yoyo: true,
		})
		.to(el21, {
			ease: easeAnimate,
			duration: time,
			x: '4em',
			y: '6.9em',
		}, 0)
		.to(el21, {
			ease: easeAnimate,
			duration: time,
			x: '8.6em',
			y: '6.3em',
			repeat: -1,
			yoyo: true,
		})
		.to(el23, {
			ease: easeAnimate,
			duration: time,
			x: '4em',
			y: '6.9em',
			rotate: 0,
		}, 0)
		.to(el23, {
			ease: easeAnimate,
			duration: time,
			x: '8.7em',
			y: '7.4em',
			rotate: 12.56,
			repeat: -1,
			yoyo: true,
		})
		.to(el24, {
			ease: easeAnimate,
			duration: time,
			x: '4em',
			y: '6.9em',
		}, 0)
		.to(el24, {
			ease: easeAnimate,
			duration: time,
			x: '7.4em',
			y: '6.4em',
			repeat: -1,
			yoyo: true,
		});
};

const lighting = (el) => {
	const parent = 	el;
	const sensor = parent.querySelectorAll('.scheme-2-3__inner--15, .scheme-2-3__inner--16');

	sensor.forEach((element, elementIndex) => {
		const tm = gsap.timeline({
			repeat: -1,
			delay: 1 * elementIndex,
			yoyo: true,
		});

		fullAnimation.add(tm.play(), 0);

		const circles = element.querySelectorAll('.picture');

		tm
			.to(circles, {
				duration: 0.6,
				ease: Power0.easeInOut,
				autoAlpha: 1,
				stagger: 0.4,
			});
	});
};

const init = (el) => {
	stepOne(el);
	lighting(el);
};

const play = () => {
	if (fullAnimation && fullAnimation.paused()) {
		fullAnimation.play();
	}
};

const pause = () => {
	if (fullAnimation && !fullAnimation.paused()) {
		fullAnimation.pause();
	}
};

export default {
	init,
	play,
	pause,
};
